angular.module('iw.frontyard.signup')
    .constant('SignupProductChoices',
        [
            { name: 'Credit Line', value: 'credit_line' },
            { name: 'Small Business Loan', value: 'small_business_loan' },
        ]
    );